7<template>
  <v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-card
      width="100%"
      style="border-radius:10px;"
      class="pa-3"
      v-show="!overlay"
    >
      <v-card-title class="title font-weight-light">
        Swap Vehicle
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-card-text>
        <div class="d-flex">
          <v-btn
            color="#00ACDC"
            dark
            class="mb-2 ml-auto"
            @click="selectRange = true"
          >
            SELECT RANGE DATE BOOKING
          </v-btn>
        </div>
        <v-data-table
          :headers="headersPools"
          :items="getBookData"
          item-key="book_id"
          sort-by="book_detail.start_datetime"
          class="font-weight-light"
          :loading="loadingSwop"
          loading-text="Loading..."
          :footer-props="footerProps"
          @update:options="updatePaging"
          :server-items-length="total"
          :options.sync="paginationOptions"
        >
          <template #body="{ items }">
            <tbody>
              <tr
                v-if="!items.length"
                class="v-data-table__empty-wrapper"
              >
                <td colspan="9">
                  No data available
                </td>
              </tr>
              <tr
                v-else
                :class="{ merah: checkAvailable(item) == 'No' }"
                v-for="item in items"
                :key="item.id"
              >
                <td>  {{ ((paginationOptions.page - 1) * paginationOptions.itemsPerPage) + getBookData.indexOf(item) + 1 }}</td>
                <td>{{ item.first_name }}</td>
                <td>{{ item.last_name }}</td>
                <td>
                  {{ startDateFormat(item.book_detail) }}
                </td>
                <td>
                  {{ endDateFormat(item.book_detail) }}
                </td>
                <td>
                  <span v-if="checkAvailable(item) === 'Yes'">
                    {{ getVehicleName(item.book_detail) }}
                  </span>
                  <v-tooltip
                    bottom
                    v-else
                    :open-delay="300"
                    content-class="maintenance"
                  >
                    <template #activator="{ on, attrs }">
                      {{ getVehicleName(item.book_detail) }}
                      <v-icon
                        class="maintenance-icon"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-alert-outline
                      </v-icon>
                    </template>
                    <span>Vehicle is scheduled for maintenance at {{ getDurationMaintenance(item) }}</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-chip
                    v-if="checkAvailable(item) === 'Yes'"
                    class="ma-2"
                    color="green"
                    text-color="white"
                    small
                  >
                    Yes
                  </v-chip>
                  <v-tooltip
                    bottom
                    v-else
                    :open-delay="300"
                  >
                    <template #activator="{ on, attrs }">
                      <v-chip
                        class="ma-2"
                        color="orange"
                        text-color="white"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        No
                      </v-chip>
                    </template>
                    <span>{{ setTextNoAvailable(item) }}</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-icon
                    @click="editItem(item)"
                    color="primary"
                    v-if="checkCanEdit(item)"
                  >
                    mdi-swap-horizontal
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </template>
          <template #[`item.no`]=" { item }">
            {{ ((paginationOptions.page - 1) * paginationOptions.itemsPerPage) + getBookData.indexOf(item) + 1 }}
          </template>
          <template #[`item.book_detail.vehicle_name`]="{ item }">
            {{ getVehicleName(item.book_detail) }}
          </template>
          <template #[`item.book_detail.available`]="{ item }">
            <v-chip
              v-if="checkAvailable(item) === 'Yes'"
              class="ma-2"
              color="green"
              text-color="white"
              small
            >
              Yes
            </v-chip>
            <v-tooltip
              bottom
              v-else
              :open-delay="300"
            >
              <template #activator="{ on, attrs }">
                <v-chip
                  class="ma-2"
                  color="orange"
                  text-color="white"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  No
                </v-chip>
              </template>
              <span>{{ setTextNoAvailable(item) }}</span>
            </v-tooltip>
          </template>
          <template #[`item.action`]="{ item }">
            <v-icon
              @click="editItem(item)"
              color="primary"
              v-if="checkCanEdit(item)"
            >
              mdi-swap-horizontal
            </v-icon>
          </template>
          <template #[`item.book_detail.start_datetime`]="{ item }">
            {{ startDateFormat(item.book_detail) }}
          </template>
          <template #[`item.book_detail.end_datetime`]="{ item }">
            {{ endDateFormat(item.book_detail) }}
          </template>
        </v-data-table>
        <v-dialog
          v-model="selectRange"
          max-width="500"
          width="500"
          persistent
        >
          <v-card
            width="100%"
            style="border-radius:10px;"
            class="pa-10"
            outlined
            height="560"
          >
            <v-toolbar
              light
              flat
            >
              <v-spacer />
              <div class="pt-3">
                <p class="text-center headline">
                  <v-icon
                    color="#00ACDC"
                    class="mx-2"
                  >
                    mdi-calendar
                  </v-icon>Select Range Date Booking
                </p>
              </div>
              <div class="flex-grow-1" />
            </v-toolbar>
            <v-card-text class="my-0">
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-container>
                  <v-row dense>
                    <v-col
                      cols="12"
                      sm="12"
                    >
                      <date-picker
                        v-model="datePicker.start"
                        :masks="datePicker.masks"
                        :min-date="datePicker.minimum"
                      >
                        <template #default="{ inputValue, inputEvents }">
                          <v-text-field
                            :value="inputValue"
                            label="From Date"
                            v-on="inputEvents"
                            outlined
                            clearable
                            :rules="[(v) => {
                              if (!datePicker.end) return true;
                              return !!v || 'Start date is required!'
                            }]"
                          />
                        </template>
                      </date-picker>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                    >
                      <date-picker
                        v-model="datePicker.end"
                        :masks="datePicker.masks"
                        :min-date="datePicker.start"
                      >
                        <template #default="{ inputValue, inputEvents }">
                          <v-text-field
                            :value="inputValue"
                            label="To Date"
                            v-on="inputEvents"
                            outlined
                            clearable
                            :rules="[(v) => {
                              if (!datePicker.start) return true;
                              return !!v || 'End date is required!'
                            }]"
                          />
                        </template>
                      </date-picker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-row>
                <v-col
                  cols="6"
                  sm="6"
                >
                  <v-btn
                    @click="close"
                    block
                    type="submit"
                    color="error"
                  >
                    CLOSE
                  </v-btn>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                >
                  <v-btn
                    @click="saveRange"
                    block
                    type="submit"
                    color="success"
                    :loading="loadingUpdate"
                    :disabled="loadingUpdate"
                  >
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialog"
          max-width="500"
          width="500"
          persistent
        >
          <v-card
            width="100%"
            style="border-radius:10px;"
            class="pa-10"
            outlined
          >
            <v-toolbar
              light
              flat
            >
              <v-spacer />
              <div class="pt-3">
                <p class="text-center headline">
                  <v-icon
                    color="#00ACDC"
                    class="mx-2"
                  >
                    mdi-calendar
                  </v-icon>Swap Vehicle
                </p>
              </div>
              <div class="flex-grow-1" />
            </v-toolbar>
            <v-card-text class="my-0">
              <v-form
                ref="formEdit"
                v-model="valid"
                lazy-validation
              >
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                    >
                      <v-select
                        v-if="false"
                        v-model="editedItem.selectedVehicle"
                        :items="getVehicles"
                        :item-text="(item) => `${item.device_make} - ${item.device_name}`"
                        :item-value="(item) => `${item.vehicle_id}`"
                        label="Booked Vehicle"
                        disabled
                        hide-details
                        outlined
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                    >
                      <v-autocomplete
                        v-model="editedItem.newVehicle"
                        :items="getEditVehicles"
                        :loading="getVehicleLoading"
                        :disabled="getVehicleLoading"
                        :item-text="(item) => getTextNewVehicle(item)"
                        :item-value="(item) => `${item.id}`"
                        :label="`Select New ${editedItem.selectedVehicle ? 'Vehicle' : 'Asset'}`"
                        outlined
                        :rules="[(v) => !!v || 'New Vehicle is required']"
                      >
                        <template #selection="{ item }">
                          <span>{{ getTextNewVehicle(item) }}</span>
                        </template>
                        <template #item="{ item }">
                          <span :style="{ fontWeight: item.hasOwnProperty('is_same_booking_group') ? 'bold' : '' }">{{ getTextNewVehicle(item) }}</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-row>
                <v-col
                  cols="6"
                  sm="6"
                >
                  <v-btn
                    @click="closeEdit"
                    block
                    type="submit"
                    color="error"
                  >
                    CLOSE
                  </v-btn>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                >
                  <v-btn
                    @click="saveEdit"
                    block
                    type="submit"
                    color="success"
                    :loading="loadingUpdate"
                    :disabled="loadingUpdate"
                  >
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */

const qs = require("qs");
import moment from "moment";
import isNull from "lodash/isNull";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";
import sortBy from "lodash/sortBy";
import get from "lodash/get";

export default {
  data() {
    return {
			range: {
        start: new Date(),
        end: new Date(),
			},
			datePicker: {
				start: "",
				startUnix: "",
				endUnix: "",
				end: "",
        masks: {
          input: "DD MMMM YYYY",
        },
        selectedDate: new Date().toISOString().substr(0, 10),
        minimum: new Date(),
      },
			masks: {
        input: "YYYY-MM-DD",
      },
      menu2: false,
      time: null,
      menu3: false,
      tabs: null,
      isPast: false,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      editedItem: {
        clientid: "",
        id: "",
        book_detail: {
          start_geofence_id: "",
          start_datetime: "",
          end_datetime: "",
        },
        passenger_count: "",
      },
      dialog: false,
      headersPools: [
        { text: "No", value: "no", sortable: false },
        { text: 'First Name', align: 'left', value: 'first_name' },
        { text: 'Last Name', align: 'left', value: 'last_name' },
        { text: "Start Date", value: "book_detail.start_datetime" },
        { text: "End Date", value: "book_detail.end_datetime" },
        { text: "Vehicle Name", value: "book_detail.vehicle_name", sortable: false },
        { text: "Availability", value: "book_detail.available" },
        { text: "Swap", value: "action", sortable: false },
			],
			selectRange: false,
      userChart: [],
      booked: 0,
      getBookData: [],
      getBookedData: [],
      getVehicles: [],
      getVehicleLoading: false,
      getEditVehicles: [],
      no_passenger: "",
      responsive: true,
      getDevice: 0,
      deviceLoaded: false,
      chartNull: false,
      countDevice: 0,
      dataPool: [],
      dataPools: [],
      notBooked: 0,
      updatedVehicle: "",
      start: null,
      match: [],
      not_match: [],
      end: null,
      now: null,
      e1: 1,
      selectedOrigin: "",
      detailValidate: true,
      oriGeoId: "",
      parent_id: "",
      sharedBook: false,
      startDateTime: "",
      endDateTime: "",
      noPassenger: "",
      selectedVehicle: "",
      selectedAddr: "",
      setAddr: "",
      sharedVehicle: false,
      setDestination: "",
      selectedStartDate: "",
      selectedStartTime: "",
      showSuccess: false,
      setVehicleName: "",
      loader: null,
      snackbar: false,
      options: [],
      text: "LOADING ...",
      entries: [],
      items: [],
      isLoading: false,
      model: null,
      // isEmpty: false,
      search: null,
      type_of_vehicle: [
        "Passenger Car 5 Seats",
        "Passenger Car 7-8 Seats",
        "Ute",
        "Other",
      ],
      center: { lat: -23.8511901, lng: 131.2038283 },
      zoom: 4,
      gmapOption: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      numberRule: (v) => {
        if (!v.trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 0 && v <= 99) return true;
        return "Number of passenger must to be more than 1";
      },
      oriPosition: { lat: 0, lng: 0 },
      chartsLib: null,
      availTl: "",
      gChartOptions: {
        timeline: {
          showRowLabels: false,
        },
        hAxis: {
          format: "HH:mm",
        },
        colors: ["#66bb6a", "#e57373"],
        width: 1055,
        height: 100,
        avoidOverlappingGridLines: false,
      },
      canEdit: false,
      destPosition: null,
      vehicleId: null,
      setConfirmBook: [],
      token: this.$store.state.token,
      userId: this.$store.state.user.user.id,
      valid: true,
      selectRules: [(v) => !!v || "Item is required"],
      dateRules: [(v) => !!v || "Item is required"],
      destAddr: "",
      selectedId: "",
      endDateDialog: false,
      display: false,
      loadingSwop: false,
      loadingUpdate: false,
      loader: null,
      searchData: "",
      searchDataTimeout: null,
      overlay: false,
      total: 0,
      footerProps: {
        itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
      },
      paginationOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      },
      isFromService: false,
      vehicleFromService: '',
      classTable: 'font-weight-light'
    };
  },
  created() {
    //data booked
    this.$store.dispatch("GET_ALL_GEOFENCES");
    this.$store.dispatch("GET_GEOFENCES");

    //data for origin
    this.$store.dispatch("LOAD_POOL_DATA");
    this.getAllDevice();
    this.getDataVehicles();
    setTimeout(() => {
      this.$store.dispatch("LOAD_POOL_DATA");
    }, 1e3);
    this.overlay = true;
  },
  watch: {
    "datePicker.start"(value) {
			let sDate = moment(value).format("YYYY-MM-DD");
			let unix = moment(sDate).unix()
			this.datePicker.startUnix = unix;
      this.$refs.form.resetValidation();
		},
		"datePicker.end"(value) {
      let sDate = moment(value).format("YYYY-MM-DD");
			let unix = moment(sDate).unix()
			this.datePicker.endUnix = unix
      this.$refs.form.resetValidation();
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 2e3)
    },
    searchData() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];
        // let defaultStart = new Date();
        let defaultStartUnix = "";
        // var nextWeek = new Date(defaultStart.getTime() + 7 * 24 * 60 * 60 * 1000);
        let defaultEndUnix = "";
        //
        // let sDate = moment(defaultStart).format("YYYY-MM-DD");
        // let unix = moment(sDate).unix()
        // defaultStartUnix = unix;
        // let eDate = moment(nextWeek).format("YYYY-MM-DD");
        // let Endunix = moment(eDate).unix()
        // defaultEndUnix = Endunix;

        if (this.datePicker.startUnix && this.datePicker.endUnix) {
          defaultStartUnix = this.datePicker.startUnix
          defaultEndUnix   = this.datePicker.endUnix
        }

        this.getTotal(defaultStartUnix, defaultEndUnix);
        this.getData(defaultStartUnix, defaultEndUnix);
      }, 1e3)
    }
  },
  computed: {
    fields() {
      if (!this.model) return [];
      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key] || "n/a",
        };
      });
    },
    destination() {
      return this.entries.map((entry) => {
        const key = btoa(`${entry.address}-${entry.lat}-${entry.lng}`);
        return Object.assign({}, entry, { key });
      });
    },
    getPoolData() {
      return this.$store.getters.getPoolData;
    },
    getAvailVehicle() {
      return this.$store.getters.getVehiclesData;
    },
    getDestinationData() {
      return this.$store.getters.getDestinationData;
    },
    all_geofences() {
      return this.$store.getters["getAllGeofencesData"];
    },
    geofences() {
      return this.$store.getters["getGeofencesData"];
    },
  },
  mounted() {
		// let defaultStart = new Date();
		// let defaultStartUnix = "";
		// var nextWeek = new Date(defaultStart.getTime() + 7 * 24 * 60 * 60 * 1000);
		// let defaultEndUnix = "";
    const { vehicle_id, start, end } = this.$route.params;
    if(!isUndefined(vehicle_id && start)){
      this.isFromService = true;
      this.vehicleFromService = vehicle_id;
      this.getTotal(start, end);
      this.getData(start, end);
    } else {
      // let sDate = moment(defaultStart).format("YYYY-MM-DD");
      // let unix = moment(sDate).unix()
      // defaultStartUnix = unix;
      // let eDate = moment(nextWeek).format("YYYY-MM-DD");
      // let Endunix = moment(eDate).unix()
      // defaultEndUnix = Endunix;
      // this.getTotal(defaultStartUnix, defaultEndUnix);
      // this.getData(defaultStartUnix, defaultEndUnix);
      this.getTotal();
      this.getData();
    }
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    setTextNoAvailable(item){
      let text = "-"
      if(item.hasOwnProperty("available_desc")) {
        text = get(item, "available_desc", "-")
      }
      return text;
    },
		close() {
      this.$nextTick(() => {
        this.selectRange = false;
        this.$refs.form.resetValidation()
        // this.datePicker.start = null;
        // this.datePicker.end = null;
      })
		},
		closeEdit() {
			this.dialog = false;
			this.editedItem.newVehicle = null
		},
		saveEdit() {
      if (this.$refs.formEdit.validate()) {
				this.token = this.$store.state.token;
        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;
				const data = {id: this.editedItem.id};
        if (this.editedItem.selectedVehicle) {
          data.vehicle_id = this.editedItem.newVehicle;
        } else {
          data.asset_id = this.editedItem.newVehicle;
        }
				this.$store.dispatch('API_CALL', {
          $method: 'update_book',
          $postData: {
            swop_vehicle: 1,
						data: data
					},
        }).then(
					(response) => {
						if(response.data.code == 200) {
							this.$swal({
								icon: 'success',
								title: response.data.data.message,
								text: 'Succes Swap Vehicles',
              })
              // let defaultStart = new Date();
              let defaultStartUnix = "";
              // var nextWeek = new Date(defaultStart.getTime() + 7 * 24 * 60 * 60 * 1000);
              let defaultEndUnix = "";
              //
              // let sDate = moment(defaultStart).format("YYYY-MM-DD");
              // let unix = moment(sDate).unix()
              // defaultStartUnix = unix;
              // let eDate = moment(nextWeek).format("YYYY-MM-DD");
              // let Endunix = moment(eDate).unix()
              // defaultEndUnix = Endunix;

              if (this.datePicker.startUnix && this.datePicker.endUnix) {
                defaultStartUnix = this.datePicker.startUnix
                defaultEndUnix   = this.datePicker.endUnix
              }

              this.getTotal(defaultStartUnix, defaultEndUnix);
              this.getData(defaultStartUnix, defaultEndUnix);
							// this.getData();
							this.close();
							this.closeEdit();
						} else {
							this.$swal({
								icon: 'error',
								title: response.data.data.message,
							})
						}
					})

			}
		},
		saveRange() {
      if (!this.$refs.form.validate()) return;
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      this.getTotal(this.datePicker.startUnix, this.datePicker.endUnix);
			this.getData(this.datePicker.startUnix, this.datePicker.endUnix);
			this.selectRange = false
		},
    getConfirmVehicleName(selectedOrigin) {
      if (selectedOrigin == null) return;
      let metadata = "";
      let getModel = "";
      if (selectedOrigin.hasOwnProperty("vehicle_name")) {
        getModel = this.getVehicles.find(
          (veh) => veh.id == selectedOrigin.vehicle_id
        )
        metadata = `${selectedOrigin.vehicle_name} - ${getModel.device_make} ${getModel.device_model.replace(
          /[^\w\s]/gi,
          ""
        )}`;
      } else if (!isNull(selectedOrigin.asset_id)) {
        metadata = `${selectedOrigin.asset_type} - ${
          selectedOrigin.asset_number
        }`;
      } else {
        metadata = "--";
      }
      if (!metadata) return;
      return metadata;
    },
    getVehicleName(item) {
      if (item == null) return;
      let metadata = "";
      if (!isNull(item.vehicle_id)) {
        metadata = `Vehicle - ${item.vehicle_name || 'REMOVED'}`;
      } else if (!isNull(item.asset_id)) {
        metadata = `${item.asset_type_name} - ${item.asset_number}`;
      } else {
        metadata = "--";
      }
      if (!metadata) return;
      return metadata;
		},
		checkAvailable(item) {
      if (item.hasOwnProperty("available")) {
        if (item.available == "No") {
          return 'No';
        }
      }
      return 'Yes';
    },
    checkCanEdit(item){
			if(!item.book_detail) return false
			let getVehicle = this.getVehicles.find((vehicle) => vehicle.id == item.book_detail.vehicle_id);
			let no_avail = get(getVehicle, "metadata.no_available_periode", {});
			if(!isEmpty(no_avail)) {
				let startBook = moment(item.book_detail.start_datetime).format("YYYY-MM-DD");
				let endBook = moment(item.book_detail.end_datetime).format("YYYY-MM-DD");
				let startBookUnix = moment(startBook).unix();
				let endBookUnix = moment(endBook).unix();
				let vehicleStart = moment(no_avail.start_date).unix();
				let vehicleEnd = moment(no_avail.end_date).unix();
				// if(vehicleStart >= startBookUnix || endBookUnix <= vehicleEnd) {
				// 	return true;
				// } else {
				// 	return false;
        // }
        return true
      }
      return true
		},
    getDates(selectedOrigin) {
      if (selectedOrigin == null) return;
      if (selectedOrigin.hasOwnProperty("start_datetime")) {
        const start = moment(selectedOrigin.start_datetime, "YYYY-MM-DD");
        const end = moment(selectedOrigin.end_datetime, "YYYY-MM-DD");
        const duration = moment.duration(end.diff(start));
        const day = duration.days();
        if (day == 0) {
          if (start == moment().format("YYYY-MM-DD")) {
            return "Today";
          } else {
            return `${start.format("D MMM YYYY")}`;
          }
        } else {
          return `${start.format("D")} \u2014 ${end.format("D")} ${start.format(
            "MMM YYYY"
          )}`;
        }
      }
    },
    getDuration(selectedOrigin) {
      if (selectedOrigin == null) return;
      if (selectedOrigin.hasOwnProperty("start_datetime")) {
        const start = moment(selectedOrigin.start_datetime).format("HH:mm");
        const end = moment(selectedOrigin.end_datetime).format("HH:mm");
        return `${start} \u2014 ${end}`;
      }
    },
    startDateFormat(item) {
      if (item == null) return;
      let date = null;
      if (item.hasOwnProperty("start_datetime")) {
        date = moment(item.start_datetime).format('D MMM YYYY HH:mm')
      }
      return date;
    },
    endDateFormat(item) {
      if (item == null) return;
      let date = null;
      if (item.hasOwnProperty("end_datetime")) {
        date = moment(item.end_datetime).format('D MMM YYYY HH:mm')
      }
      return date;
    },
    formatDate(date, format = 'DD MMM YYYY HH:mm') {
      return moment(date).format(format)
    },
    getTotal(startDate, endDate) {
      let start_date = ""
      let end_date = ""

      if (this.isFromService) {
        start_date = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
        end_date   = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
      } else {
        start_date = moment.unix(startDate).format('YYYY-MM-DD') + ' 00:00:00';
        end_date   = moment.unix(endDate).format('YYYY-MM-DD') + ' 23:59:59';
      }

      const postData = {
        clientid: this.$store.state.clientid,
        status: 2,
        query: this.searchData,
        start_date: start_date,
        end_date: end_date,
        check_available: 1
      };

      if (!startDate) delete postData.start_date;
      if (!endDate) delete postData.end_date;

      this.$store.dispatch('API_CALL', {
          $method: 'get_book_total',
          $postData: postData,
        })
        .then((response) => {
          this.total = parseInt(response.data.data.total);
        });
    },
    getData(startDate, endDate) {
      this.loadingSwop = true;
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;

      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by    = sortBy.length ? sortBy[0] : 'book_detail.available';
      const sort_dir   = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'desc';

      let start_date = ""
      let end_date = ""

      if (this.isFromService) {
        start_date = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
        end_date   = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
      } else {
        start_date = moment.unix(startDate).format('YYYY-MM-DD') + ' 00:00:00';
        end_date   = moment.unix(endDate).format('YYYY-MM-DD') + ' 23:59:59';
      }
      const offset     = (page - 1) * itemsPerPage
      const limit      = itemsPerPage

      let by = 'book_detail.available';

      switch(sort_by) {
        case 'first_name':
            by = 'first_name';
            break;
        case 'last_name':
            by = 'last_name';
            break;
        case 'book_detail.start_datetime':
            by = 'start_date';
            break;
        case 'book_detail.end_datetime':
            by = 'end_date';
            break;
        case 'book_detail.available':
            by = 'is_available';
            break;
        default:
          break;
      }

      const postData = {
        token: this.$store.state.token,
        clientid: this.$store.state.clientid,
        query: this.searchData,
        start_date,
        end_date,
        offset,
        limit,
        sort_by: by,
        sort_dir,
        status: 2,
        check_available: 1,
      };
      if(this.isFromService) {
        postData.vehicle_id = this.vehicleFromService;
        this.classTable = 'merah'
      }

      if (!startDate) delete postData.start_date;
      if (!endDate) delete postData.end_date;

			this.$store.dispatch('API_CALL', {
          $method: 'get_all_book',
          $postData: postData,
        })
				.then((response) => {
					this.loadingSwop = false;
          this.loadingUpdate = false;
          this.loader = this.loadingUpdate;
          this.getBookData = response.data.data;

          // const schedules = response.data.data.filter((schedule) => {
					// 	let start = moment(schedule.book_detail.start_datetime).format("YYYY-MM-DD");
					// 	let startUnix = moment(start).unix();
					// 	let end = moment(schedule.book_detail.end_datetime).format("YYYY-MM-DD");
					// 	let endUnix = moment(end).unix();
					// 	return startUnix >= startDate && endUnix <= endDate;
					// })
					// this.getBookData = schedules.filter(
					// 	(booking) => booking.book_detail.status == 2
					// );
				});
    },
    getDataVehicles() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      this.$store.dispatch('API_CALL', {
          $method: 'get_vehicles',
          $postData: {
            clientid: this.clientid,
          },
        })
        .then((response) => {
          this.getVehicles = response.data.data;
					this.getDevice = response.data.data.length;
					this.getEditVehicles = response.data.data;
          this.deviceLoaded = true;
        });
		},
    cancelBooking(item) {
      // $swal function calls SweetAlert into the application with the specified configuration.
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        showCancelButton: true,
        confirmButtonText: "Yes, Cancel this Booking!",
        cancelButtonText: "No, Keep it!",
      }).then((result) => {
        // <--
        const userIndex = this.getBookData.findIndex(
          (d) => d.book_id == item.book_id
        );
        if (result.value) {
          // <-- if confirmed
          this.token = this.$store.state.token;
          this.$store.dispatch('API_CALL', {
            $method: 'delete_book',
            $postData: {
              book_id: item.book_id,
            },
          });
          this.getBookData.splice(userIndex, 1);
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Success Delete Booking",
          });
        }
      });
    },
    onDelete(book_id) {
      this.clientid = this.$store.state.clientid;
      this.token = this.$store.state.token;
    },
    getVehicleId(vehicles) {
      if (!vehicles) return;
      this.vehicleId = vehicles.vehicle_id;
      if (vehicles.hasOwnProperty("vehicle_name")) {
        this.setVehicleName = vehicles.vehicle_name;
      } else if (vehicles.hasOwnProperty("name")) {
        this.setVehicleName = vehicles.name;
      }
      this.e1 = 3;
    },
    async editItem(item) {
      if (this.$refs.formEdit) {
        this.$refs.formEdit.reset();
      }
      this.dialog = true;
      const vehicle_id = get(item, "book_detail.vehicle_id", "")
			const asset_id = get(item, "book_detail.asset_id", "")
      this.editedItem.selectedVehicle = vehicle_id;
			this.editedItem.selectedAsset = asset_id;
			this.editedItem.id = item.id;
      this.getVehicleLoading = true;
			this.getEditVehicles = await this.getAvailableVehicle(item);
      this.getVehicleLoading = false;
    },
    insideRange(booking, workingDay, workingTime) {
      if (workingDay.length == 0 && workingTime.start == '' && workingTime.end == '') return true;
      const start = moment(booking.start_datetime);
      const startDate = moment(booking.start_datetime).format('YYYY-MM-DD');
      const end = moment(booking.end_datetime);
      const endDate = moment(booking.end_datetime).format('YYYY-MM-DD');
      const insideWorkingDay = workingDay.length ? workingDay.includes(start.day().toString()) : true;
      if (!insideWorkingDay) return false;
      if (startDate != endDate) return false;
      if (moment(`${startDate} ${workingTime.start}`).isAfter(start)) return false;
      if (moment(`${endDate } ${workingTime.end}`).isBefore(end)) return false;
      return true;
    },
    getAvailableVehicle(item) {
      const { token, clientid } = this.$store.state;
      this.deviceLoaded = false;
      let metadata = {};

      try {
        metadata = JSON.parse(item.book_detail.metadata);
      } catch(e) {}

      const groupId = get(metadata, 'booking_detail.group_id', null);

      return this.$store.dispatch('API_CALL', {
          $method: 'get_available_vehicle',
          $postData: {
            clientid,
            group_id: groupId,
            start_date: item.book_detail.start_datetime,
            end_date: item.book_detail.end_datetime,
            user_id: item.book_detail.book_user.user_id,
            origin_id: item.book_detail.start_geofence_id
          },
        })
        .then((response) => {
          const vehicles = sortBy(get(response, 'data.data.data', []), ['device_make', 'device_name']);
          return vehicles.filter(vehicle => {
              let metadata = {};
              try {
                metadata = JSON.parse(vehicle.metadata);
              } catch(e) {}
              if (!metadata) metadata = {};
              const workingDay = get(metadata, 'working_day', []);
              const workingTime = get(metadata, 'working_time', {start: '', end: ''});
              const isInsideRange = this.insideRange(item.book_detail, workingDay, workingTime);
              return isInsideRange;
          });
        });
    },
    onResponsiveInverted() {
      if (window.innerWidth < 1024) {
        this.responsive = false;
      } else {
        this.responsive = true;
      }
    },
    getAllDevice() {
      this.token = this.$store.state.token;
      this.deviceLoaded = false;
      this.clientid = this.$store.state.clientid;
      this.$store.dispatch('API_CALL', {
          $method: 'get_all_device',
          $postData: {
            clientid: this.clientid,
          },
        })
        .then((response) => {
          const getData = response.data.data;
        });
    },
    getAddress(item) {
      const data = JSON.parse(item.metadata);
      return data.created_date;
    },
    updatePaging(options) {
      // let defaultStart = new Date();
      let defaultStartUnix = "";
      // var nextWeek = new Date(defaultStart.getTime() + 7 * 24 * 60 * 60 * 1000);
      let defaultEndUnix = "";
      //
      // let sDate = moment(defaultStart).format("YYYY-MM-DD");
      // let unix = moment(sDate).unix()
      // defaultStartUnix = unix;
      // let eDate = moment(nextWeek).format("YYYY-MM-DD");
      // let Endunix = moment(eDate).unix()
      // defaultEndUnix = Endunix;

      if (this.datePicker.startUnix && this.datePicker.endUnix) {
        defaultStartUnix = this.datePicker.startUnix
        defaultEndUnix   = this.datePicker.endUnix
      }

      this.paginationOptions = options;
      const { vehicle_id, start, end } = this.$route.params;
      if(!isUndefined(vehicle_id && start)){
        this.isFromService = true;
        this.vehicleFromService = vehicle_id;
        this.getTotal(start, end);
        this.getData(start, end);
      } else {
        this.getTotal(defaultStartUnix, defaultEndUnix);
        this.getData(defaultStartUnix, defaultEndUnix);
      }
    },
    getDurationMaintenance(item) {
      let startService = this.formatDate(item.start_service, 'DD MMMM YYYY');
      const endService = this.formatDate(item.end_service, 'DD MMMM YYYY');
      if (startService !== endService) startService += ` to ${endService}`;
      return startService;
    },
    getTextNewVehicle(item) {
      if (item.hasOwnProperty('device_name')) {
        return `${item.device_make} - ${item.device_name}`;
      } else {
        return `${item.number} - ${item.description}`;
      }
    }
  },
};
</script>
<style lang="css" scoped>
  .maintenance {
    background-color: #D32F2F;
  }
  .maintenance-icon {
    color: #D32F2F;
    caret-color: #FFEBEE;
  }
  .merah {
    background-color:#f3b6b6 ;
  }
  .v-sheet--offset {
    top: -24px;
    position: relative;
    border-radius: 14px;
  }
  .text-class{
    top: -10px;
  }
  .text-offset{
    bottom: -24px;
  }
  .icon-clas{
    top: -15px;
  }
  .custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.vs__search {
  height: 45px;
}
.vs {
  color: #ff5252 !important;
  border: 2px solid #ff5252 !important;
  border-radius: 5px;
  font-size: 400 15.3333px Arial;
}
.noerror {
  border-radius: 5px;
  font-size: 400 15.3333px Arial;
}
</style>
